import React from 'react';
import { Route } from 'react-router-dom';
import slug from 'constants/slug';
import LegalDocumentList from './LegalDocumentList';
import LegalDocumentCreate from './LegalDocumentCreate';
import LegalDocumentView from './LegalDocumentView';
import LegalDocumentEdit from './LegalDocumentEdit';


export default (props) => [
  <Route
    exact
    key={slug.LEGAL_DOCUMENTS.VIEW}
    path={slug.LEGAL_DOCUMENTS.VIEW}
    render={(matchProps) => <LegalDocumentView {...matchProps} {...props} />}
  />,
  <Route
    exact
    key={slug.LEGAL_DOCUMENTS.LIST}
    path={slug.LEGAL_DOCUMENTS.LIST}
    render={(matchProps) => (
      <LegalDocumentList {...matchProps} {...props} typeSearch='form_2' />
    )}
  />,
  <Route
    key={slug.LEGAL_DOCUMENTS.CREATE}
    path={slug.LEGAL_DOCUMENTS.CREATE}
    render={(matchProps) => <LegalDocumentCreate {...matchProps} {...props} />}
  />,
  <Route
    key={slug.LEGAL_DOCUMENTS.EDIT}
    path={slug.LEGAL_DOCUMENTS.EDIT}
    render={(matchProps) => <LegalDocumentEdit {...matchProps} {...props} />}
  />,
];



// WEBPACK FOOTER //
// ./src/containers/LegalDocument/index.js